import { render, staticRenderFns } from "./campus-schedule.vue?vue&type=template&id=f8f85fe8&scoped=true"
import script from "./campus-schedule.vue?vue&type=script&lang=js"
export * from "./campus-schedule.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./campus-schedule.vue?vue&type=style&index=1&id=f8f85fe8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8f85fe8",
  null
  
)

export default component.exports